import React, {useState, useEffect, useContext, useRef} from 'react';
import { Grid, Column, Theme } from '@carbon/react';
import HomeTable from './HomeTable';
import {getListHeaderDocAll} from '../../services/services';
import {ThemeContext} from '../../context/ThemeProvider';
import CommodityHeader from '../../components/Header';
import SessionController from '../../components/FrontSessionController/SessionController';

const Home = () => {
  
  const [rows, setRows] = useState([]);
  const [headers, setHeaders] = useState([]);
  const theme = useContext(ThemeContext);
  const email = theme.theme.email
  const profileName = theme.theme.profile;
  const userType = theme.theme.userType;
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const messageResponse = useRef([]);  
  const [messageModal, setMessageModal] = useState('');
  
  const setHeaderForInvoiceListTable = () => {
    let headersInvoiceListTable = [...defaultHeaders];
    let headerInvoiceList = {};
    if(userType === 'privilegedUser'){
      
      headerInvoiceList.key = 'runExp';
      headerInvoiceList.header = 'Run Exp';
      headersInvoiceListTable.push(headerInvoiceList);
      
      headerInvoiceList = {};
      headerInvoiceList.key = 'runGen';
      headerInvoiceList.header = 'Run Gen';
      headersInvoiceListTable.push(headerInvoiceList);
      
      
    }
    // this one needs to be here as it should always be the last one
    headerInvoiceList = {};
    headerInvoiceList.key = 'idDoc';
    headerInvoiceList.header = 'idDoc';
    headersInvoiceListTable.push(headerInvoiceList);
    setHeaders(headersInvoiceListTable);
  }

  
  let defaultHeaders = [
  
    {
      key: 'ctrycode',
      header: 'Country',
    },
    {
      key: 'formtype',
      header: 'Form Type',
    },
    {
      key: 'status',
      header: 'Status',
    },
    {
      key: 'role',
      header: 'Role',
    },
    {
      key: 'invoicenumber',
      header: 'Invoice Number',
    },
    {
      key: 'nextapprover',
      header: 'Next Approver',
    },
    {
      key: 'invonumb',
      header: 'Internal Reference',
    },
    {
      key: 'company',
      header: 'Company',
    },
    {
      key: 'supplierName',
      header: 'Supplier Name',
    },
    {
      key: 'supplierNumber',
      header: 'Supplier Number',
    },
    {
      key: 'creationDate',
      header: 'Creation Date',
    },
    {
      key: 'receptionDate',
      header: 'Reception Date',
    },
    {
      key: 'dueDate',
      header: 'Due Date',
    }
  ];

  //start controller error modal
  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  const parserDocRes = async (response) => {    
    const resParsed = response.map((res, id) => {
      /* console.log("==> response", response); */
      const parsed = {};      
        parsed["id"] = id.toString();
        parsed["ctrycode"] = res[1];
        parsed["formtype"] = res[2];
        parsed["status"] = res[3];
        parsed["role"] = res[4];
        parsed["invoicenumber"] = res[5];
        parsed["nextapprover"] = res[6];
        parsed["invonumb"] = res[7];
        parsed["company"] = res[8];
        parsed["supplierName"] = res[9];
        parsed["supplierNumber"] = res[10];
        parsed["creationDate"] = res[11];
        parsed["receptionDate"] = res[12];
        parsed["dueDate"] = res[13];
        if(userType == 'privilegedUser'){
          parsed["runExp"] = res[14];
          parsed["runGen"] = res[15];
          parsed["idDoc"] = res[16].replace(/\D/g,'');
        }else{
          parsed["idDoc"] = res[14].replace(/\D/g,'');
        }
      return parsed;
    });
    setRows(resParsed);
  };

  const getAllDocuments = async () => {
    document.body.className = 'waiting';
    await getListHeaderDocAll('','','')
    .then(response => {
        if(response.status === 200) {
          response.json()
          .then(response => {
            parserDocRes(response);
          });
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        } else{
          response.text()
            .then(response => {            
              openMessageModal(response);
            })
        }
      })    
    document.body.className = '';   
  };    
  useEffect(() => {
    if(email && profileName) {
      setHeaderForInvoiceListTable();
      getAllDocuments();
    }
    
  }, [email, profileName])
  
  return (
    <>
        <Theme theme="g90">
            <CommodityHeader />
        </Theme>
      <Grid className={"principal-grid"}>
        <Column lg={16} >
          {<HomeTable rows={rows} headers={headers} getAllDocumentsCallback={getAllDocuments} processDocsResponseCallback3={parserDocRes}/>}
          <SessionController messageLostSessionCallback={messageSessionLost} />
        </Column>        
      </Grid>
    </>
  );
};

export default Home;